import React from 'react';
import { connect } from 'react-redux';
import { Text, Button, Loader, Logo, Theme, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { logout } from '../../actions/user.js';

/**
 * 
 */
const NotFound = ({ loader, whitelabel, dispatch }) => {

    /**
     * @param {*} link 
     */
    const _navigateTo = (link) => {
        window.location.href = link;
    };

    /**
     */
    const _logout = () => {
        dispatch(logout());
    };

    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%'
        },
        buttonWrapper: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 25,
            width: 350
        }
    };

    return (
        <div style={styles.container}>
            <Logo whitelabel={whitelabel} />

            <Text largest bold>{ i18n.t(tokens.labels.notFound) }</Text>
            <Text medium>{ i18n.t(tokens.labels.notFoundSub) }.</Text>

            <div style={ styles.buttonWrapper }>
                <Button
                    onClick={() => _navigateTo('/')}
                    color="primary"
                    fullWidth
                >
                    { i18n.t(tokens.buttons.navigateToHome) }
                </Button>

                <Text small margin="10px 0 0px">{ i18n.t(tokens.labels.or) }</Text>

                <Button
                    onClick={() => _logout()}
                    transparent
                >
                    <Text medium bold color={Theme.colors.red}>{ i18n.t(tokens.buttons.logout) }</Text>
                </Button>
            </div>

            { 
                loader?.isLoading && 
                    <Loader 
                        whitelabel={ whitelabel } 
                        isContainer
                    /> 
            }
        </div>
    );
    
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    whitelabel: state.whitelabel
});

export default (connect(mapStateToProps)(NotFound));